module.exports = __webpack_public_path__ + "img/defe.59aefe88.png";